import React from 'react'
import './earn-points.less'
import { setHeader } from '@/util/set-header'
import { withRouter } from 'react-router-dom'
import { fetchEarnPoints } from '@/api/earn-point'
import { Toast } from 'antd-mobile'


@(withRouter as any)
export default class EarnPoints extends React.Component<any, any> {

    constructor(props: any) {
        super(props)

        this.state = {
            list: []
        }

            ; (window as any).signInSuccess = () => {
                Toast.show('签到成功')
                this.genData()
            }
    }

    UNSAFE_componentWillMount() {
        setHeader({
            title: '赚积分',
        })
    }

    componentDidMount() {
        this.genData()
    }

    genData = async () => {
        Toast.loading('加载中')
        const { data } = await fetchEarnPoints()
        if (data.code !== 'SUCCESS') {
            Toast.show(data.msg)
            return
        }
        this.setState({ list: data.data })
    }

    /**
     * 各种跳转
     */
    onClickEvent = (task: any) => {
        switch (task.type) {
            case 'checkin':
                if (!task.finished) {
                    if (window.WebViewBridge) {
                        window.WebViewBridge.signIn && window.WebViewBridge.signIn()
                    } else if (window.webkit) {
                        window.webkit.messageHandlers.signIn.postMessage(null)
                    }
                }
                break;
            case 'upload_face_img':
                if (!task.finished) {
                    const { history } = this.props
                    history.push(`/basic-info`)
                }
                break
            default:
                break;
        }
    }

    render() {
        const { list } = this.state

        return (
            <div>
                {
                    list.map(({ title, tasks }: any, index: number) => <div key={`row-${index}`}>
                        <span className="earn-title">{title}</span>
                        {
                            tasks.map((task: any) => <div key={`col-${index}`} className="earn-point-item">
                                <div className="left-text">
                                    <div>
                                        <div className="top">{task.text}</div>
                                        <div>{task.tip}</div>
                                    </div>
                                </div>
                                <div className="right-item">
                                    <div className="number">{task.number}</div>
                                    <div className={task.finished ? "right-text" : "right-border"} onClick={() => this.onClickEvent(task)}>{task.finished ? '已完成' : '做任务'}</div>
                                </div>
                            </div>)
                        }
                    </div>)
                }
            </div>
        )
    }
}